import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useReservationCategories } from "@/hooks/reservations/useReservationCategories";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface ReservationCategoriesProps {
  onSelectCategory: (categoryId: string, categoryName: string) => void;
}

export const ReservationCategories = ({ onSelectCategory }: ReservationCategoriesProps) => {
  const { data: categories = [], isLoading } = useReservationCategories();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {[...Array(3)].map((_, i) => (
          <Card key={i} className="animate-pulse">
            <CardHeader>
              <div className="h-4 bg-muted rounded w-3/4"></div>
            </CardHeader>
            <CardContent>
              <div className="h-20 bg-muted rounded"></div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (categories.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">
          No hay categorías de reservas disponibles en este momento.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {categories.map((category) => (
        <Card key={category.id} className="hover:shadow-lg transition-shadow cursor-pointer">
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              <span>{category.name}</span>
              <ArrowRight className="h-4 w-4 text-muted-foreground" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            {category.image_url && (
              <div className="aspect-video rounded-lg overflow-hidden mb-4">
                <img 
                  src={category.image_url} 
                  alt={category.name}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            {category.description && (
              <p className="text-sm text-muted-foreground mb-4">
                {category.description}
              </p>
            )}
            <Button 
              onClick={() => onSelectCategory(category.id, category.name)}
              className="w-full"
            >
              Ver disponibles
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};